"use client";

import type { AnchorHTMLAttributes, ReactElement } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useMessenger } from "./messenger-context";
import { helpPageIdOf } from "./messenger-sources";

const PROSE =
  "min-w-0 break-words [overflow-wrap:anywhere] [&_ol]:my-1.5 [&_ol]:list-decimal [&_ol]:pl-5 [&_p+p]:mt-2 [&_strong]:font-semibold [&_ul]:my-1.5 [&_ul]:list-disc [&_ul]:pl-5 [&_li]:my-0.5";

/** Agent text: small markdown; help links open the article inside the window. */
export function MessengerMarkdown({ text }: { readonly text: string }): ReactElement {
  const { config, nav } = useMessenger();
  const renderAnchor = ({
    href,
    children,
  }: AnchorHTMLAttributes<HTMLAnchorElement> & { readonly node?: unknown }): ReactElement => {
    const url = href ?? "";
    const pageId = helpPageIdOf(url, config.help_org_slug);
    if (pageId !== null) {
      return (
        <button
          type="button"
          onClick={() => nav.push({ kind: "article", pageId })}
          className="text-left text-action-700 underline underline-offset-2 hover:text-action-900"
        >
          {children}
        </button>
      );
    }
    const external = /^https?:\/\//.test(url);
    return (
      <a
        href={url}
        {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
        className="text-action-700 underline underline-offset-2 hover:text-action-900"
      >
        {children}
      </a>
    );
  };
  return (
    <div className={PROSE}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ a: renderAnchor }}>
        {text}
      </ReactMarkdown>
    </div>
  );
}
